import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CycleCountResponse } from '../../models/cycle-count/cycle-count-response';
import { CycleCountSaveRequest } from '../../models/cycle-count/cycle-count-save-request';
import { CycleCountZoneResponse } from '../../models/cycle-count/cycle-count-zone-response';
import { Globals } from '../../shared/globals/globals';

@Injectable({
	providedIn: 'root'
})
export class AuditCycleCount {

	private httpOptions = {
		headers: new HttpHeaders({ 'Content-type': 'application/json' }),
		params: new HttpParams()
	};

	private subRoute = "/api/v1/auditCycleCount";

	constructor(private http: HttpClient, public globals: Globals) {
		this.http = http;
		this.globals = globals;
	}

	getPartToCount(zone: string, types: string[]): Observable<CycleCountResponse[]> {
		this.clearRequest();
		this.httpOptions.params = this.httpOptions.params.append("bkLanguageC", this.globals.user.language);
		types.forEach(type => this.httpOptions.params = this.httpOptions.params.append("cycleCountTypeC", type));

		const URL = environment.backend_url + this.subRoute +
			"/findPrintedPartsOnZone"
			+ "/FRD"
			+ `/${this.globals.user.country}`
			+ `/${this.globals.user.warehouse.warehouseUidK}`
			+ `/${zone}`;
		return this.http.get<CycleCountResponse[]>(URL, this.httpOptions);
	}

	getZonesWithPartsToBeCounted(types: string[]): Observable<CycleCountZoneResponse[]> {
		this.clearRequest();
		types.forEach(type => this.httpOptions.params = this.httpOptions.params.append("cycleCountTypeC", type));

		const URL = environment.backend_url + this.subRoute +
			"/findByZones"
			+ `/${this.globals.user.warehouse.warehouseUidK}`
			+ `/${this.globals.user.warehouse.bkSubDivisionUidD}`;
		return this.http.get<CycleCountZoneResponse[]>(URL, this.httpOptions);
	}

	save(request: CycleCountSaveRequest): Observable<any> {
		this.clearRequest();
		const URL = environment.backend_url + this.subRoute + "/save";
		return this.http.post<any>(URL, request, this.httpOptions);
	}

	private clearRequest() {
		this.httpOptions.params = this.httpOptions.params.delete("bkLanguageC");
		this.httpOptions.params = this.httpOptions.params.delete("cycleCountTypeC");
	}
}
